import {
  FETCH_COURSES_OVERVIEW,
  FEATURED_COURSES,
  ALL_COURSES,
  SINGLE_COURSES_DETAILS,
  MY_COURSE_ACCESS,
  MODAL_LESSON_PREVIEW
} from '../actions';

export function overviewCourses(state = {}, action) {
  switch (action.type) {
    case FETCH_COURSES_OVERVIEW:
      return action.payload;
    default:
      return state;
  }
}

export function featuredCourses(state = {}, action) {
  switch (action.type) {
    case FEATURED_COURSES:
      return action.payload;
    default:
      return state;
  }
}

export function allCourses(state = {}, action) {
  switch (action.type) {
    case ALL_COURSES:
      return action.payload;
    default:
      return state;
  }
}

export function singleCoursesDetails(state = [], action) {
  switch (action.type) {
    case SINGLE_COURSES_DETAILS:
      return action.payload;
    default:
      return state;
  }
}

export function myCourseAccess(state = [], action) {
  switch (action.type) {
    case MY_COURSE_ACCESS:
      return action.payload;
    default:
      return state;
  }
}

export function lessonPreviewModalReducer(state = false, action) {
  switch (action.type) {
    case MODAL_LESSON_PREVIEW:
      return action.payload;
    default:
      return state;
  }
}
